// memory cache
//此容量除以用电器功率预设值得出时间（单位小时）.保留一位小数。向上四舍五入，小数点后为0.5
//Math.trunc()方法去除数字的小数部分，保留整数部分
//Math.round()方法返回一个数字四舍五入后的整数部分
function getTime(ratedCapacity,powerOfAppliance){
  let time = ratedCapacity/powerOfAppliance
  const time1 = Math.round(time)
  const time2 = Math.trunc(time)
  if(time1 === time2){
    time = time1 + 0.5
  }else{
    time = time1
  }
  return time
}

//计算进度条的process值 maxValue是100
function getProgressValue(time,value){
  return (time/value) > 1 ? 100 :  (time/value)*100
}
var imagePath = "https://cdn.shopify.com/s/files/1/0536/3390/8911/files/";
var imagePathEnd = '?v=1658976074'
const vars = {
  // 额定容量ratedCapacity
  // 用电器预设功率powerOfAppliance
  // time = getTime(ratedCapacity,powerOfAppliance) 显示在页面的时间值
  // progressValue = (time/maxTime)*100 控制进度条显示的值
  history: [],
  data: null,
  oldData: {
    1: [{
        pic: 'https://cdn.shopify.com/s/files/1/0536/3390/8911/files/choose-EB3A.png?v=1661926546',
        title: 'By your choice, we recommend this product to you', 
        sku: 'EB3A',
        desc: '600W\n268Wh\nApp Control',
        features: 'Being more energy-efficient than fuel generators, EB3A is  designed to help reduce carbon emissions to the environment.',
        videos: ['https://www.youtube.com/embed/6DBzxXUmRGw', 'https://www.youtube.com/embed/YfkJuWGDS7I','https://www.youtube.com/embed/h4sAlYVClXk'],
        ratedCapacity: 268.8,
        choices: [{
            leftLabel: 'MINI',
            powerOfAppliance:15, 
            maxTime:50,
            content: [
              {
                iconWidth: 38,
                icon: 'iphone2.svg',
                label: 'Phone',
              },
              {
                iconWidth: 38,
                icon: 'Macbook.svg',
                label: 'Laptop',
              },
              {
                iconWidth: 38,
                icon: 'Camera.svg',
                label: 'Camera',
              },
              {
                iconWidth: 38,
                icon: 'Light.svg',
                label: 'Light',
              },
              {
                iconWidth: 50,
                icon: 'switch.svg',
                label: 'Switch',
              },
              {
                iconWidth: 50,
                icon: 'WirelessSpeaker.svg',
                label: 'Wireless\nSpeaker',
              },
            ],
          },
          {
            leftLabel: 'NORMAL',
            powerOfAppliance: 100,
            maxTime:10,
            rightLabel: 1,
            content: [
              {
                iconWidth: 50,
                icon: 'cpap.svg',
                label: 'CPAP',
              },
              {
                iconWidth: 42,
                icon: 'Projector.svg',
                label: 'Projector',
              },
              {
                iconWidth: 38,
                icon: 'Drone.svg',
                label: 'Drone',
              },
              {
                iconWidth: 38,
                icon: 'CeilingFan.svg',
                label: 'Ceiling Fan',
              },
              {
                iconWidth: 42,
                icon: 'Television.svg',
                label: 'Television',
              },
              {
                iconWidth: 50,
                icon: 'Minifridge.svg',
                label: 'Mini-fridge',
              },
            ],
          },{
            leftLabel: 'HEAVY',
            powerOfAppliance:400,
            maxTime:3,
            content: [
              {
                iconWidth: 40,
                icon: 'Desktop.svg',
                label: 'Desktop',
              },
              {
                iconWidth: 34,
                icon: 'Blender.svg',
                label: 'Blender',
              },
              {
                iconWidth: 40,
                icon: 'SandwichGrill.svg',
                label: 'Sandwich\nGrill',
              },
              {
                iconWidth: 38,
                icon: 'VacuumCleaner.svg',
                label: 'Vacuum\nCleaner',
              },
              {
                iconWidth: 38,
                icon: 'CoffeeMaker.svg',
                label: 'CoffeeMaker',
              },
              {
                iconWidth: 46,
                icon: 'ElectricKettle.svg',
                label: 'Electric Kettle',
              }
            ],
          }
        ],
        buyLink: 'https://www.bluettipower.com/products/bluetti-eb3a-portable-power-station',
      },{
        pic: 'https://cdn.shopify.com/s/files/1/0536/3390/8911/files/choose-EB55.png?v=1661926545',
        title: 'By your choice, we recommend this product to you', 
        sku: 'EB55',
        desc: '700W\n537Wh\n400W Charging',
        features: 'The compact and lightweight design makes EB55 a Portable Power Station, perfect for van life or camping trips. With 537Wh capacity and built-in 700W (surge 1,400W) strong inverter, EB55 could run most of your essential outdoor electronics such as mobile phones, mini freezers, radios, projectors, and more. ',
        videos: ['https://www.youtube.com/embed/_C73l7d9jiM', 'https://www.youtube.com/embed/oQe3P4tsATs'],
        ratedCapacity: 537,
        choices: [{
            leftLabel: 'MINI',
            powerOfAppliance:15, 
            maxTime:50,
            content: [
              {
                iconWidth: 38,
                icon: 'iphone2.svg',
                label: 'Phone',
              },
              {
                iconWidth: 38,
                icon: 'Macbook.svg',
                label: 'Laptop',
              },
              {
                iconWidth: 38,
                icon: 'Camera.svg',
                label: 'Camera',
              },
              {
                iconWidth: 38,
                icon: 'Light.svg',
                label: 'Light',
              },
              {
                iconWidth: 50,
                icon: 'switch.svg',
                label: 'Switch',
              },
              {
                iconWidth: 50,
                icon: 'WirelessSpeaker.svg',
                label: 'Wireless\nSpeaker',
              },
            ],
          },
          {
            leftLabel: 'NORMAL',
            powerOfAppliance: 100,
            maxTime:10,
            content: [
              {
                iconWidth: 50,
                icon: 'cpap.svg',
                label: 'CPAP',
              },
              {
                iconWidth: 42,
                icon: 'Projector.svg',
                label: 'Projector',
              },
              {
                iconWidth: 38,
                icon: 'Drone.svg',
                label: 'Drone',
              },
              {
                iconWidth: 38,
                icon: 'CeilingFan.svg',
                label: 'Ceiling Fan',
              },
              {
                iconWidth: 42,
                icon: 'Television.svg',
                label: 'Television',
              },
              {
                iconWidth: 50,
                icon: 'Minifridge.svg',
                label: 'Mini-fridge',
              },
            ],
          },{
            leftLabel: 'HEAVY',
            powerOfAppliance:400,
            maxTime:3,
            content: [
              {
                iconWidth: 40,
                icon: 'Desktop.svg',
                label: 'Desktop',
              },
              {
                iconWidth: 34,
                icon: 'Blender.svg',
                label: 'Blender',
              },
              {
                iconWidth: 40,
                icon: 'SandwichGrill.svg',
                label: 'Sandwich\nGrill',
              },
              {
                iconWidth: 38,
                icon: 'VacuumCleaner.svg',
                label: 'Vacuum\nCleaner',
              },
              {
                iconWidth: 38,
                icon: 'CoffeeMaker.svg',
                label: 'Coffee &nbsp Maker',
              },
              {
                iconWidth: 46,
                icon: 'ElectricKettle.svg',
                label: 'Electric &nbsp Kettle',
              }
            ],
          }
        ],
        buyLink: 'https://www.bluettipower.com/products/bluetti-eb55-537wh-700w-portable-power-station',
      }, {
        pic: 'https://cdn.shopify.com/s/files/1/0536/3390/8911/products/EB70_2677d7c2-7fc1-4863-ab37-959aa0f511d6_1000x.png?v=1636541066',
        title: 'By your choice, we recommend this product to you', 
        sku: 'EB70S',
        desc: '800W\n716Wh\nLFP Battery',
        features: 'Born from ultimate innovation and state-of-the-art technologies, EB70S features the 800W power inverter and 716Wh LiFePO4 battery pack to cover the power needs of your essentials on the road or during power outages.',
        videos: ['https://www.youtube.com/embed/5v6eajHKnxo', 'https://www.youtube.com/embed/tvfTo2Ou5r0'],
        ratedCapacity: 716,
        choices: [{
            leftLabel: 'MINI',
            powerOfAppliance:15, 
            maxTime:50,
            content: [
              {
                iconWidth: 38,
                icon: 'iphone2.svg',
                label: 'Phone',
              },
              {
                iconWidth: 38,
                icon: 'Macbook.svg',
                label: 'Laptop',
              },
              {
                iconWidth: 38,
                icon: 'Camera.svg',
                label: 'Camera',
              },
              {
                iconWidth: 38,
                icon: 'Light.svg',
                label: 'Light',
              },
              {
                iconWidth: 50,
                icon: 'switch.svg',
                label: 'Switch',
              },
              {
                iconWidth: 50,
                icon: 'WirelessSpeaker.svg',
                label: 'Wireless\nSpeaker',
              },
            ],
          },
          {
            leftLabel: 'NORMAL',
            powerOfAppliance: 100,
            maxTime:10,
            content: [
              {
                iconWidth: 50,
                icon: 'cpap.svg',
                label: 'CPAP',
              },
              {
                iconWidth: 42,
                icon: 'Projector.svg',
                label: 'Projector',
              },
              {
                iconWidth: 38,
                icon: 'Drone.svg',
                label: 'Drone',
              },
              {
                iconWidth: 38,
                icon: 'CeilingFan.svg',
                label: 'Ceiling Fan',
              },
              {
                iconWidth: 42,
                icon: 'Television.svg',
                label: 'Television',
              },
              {
                iconWidth: 50,
                icon: 'Minifridge.svg',
                label: 'Mini-fridge',
              },
            ],
          },{
            leftLabel: 'HEAVY',
            powerOfAppliance:400,
            maxTime:3,
            content: [
              {
                iconWidth: 40,
                icon: 'Desktop.svg',
                label: 'Desktop',
              },
              {
                iconWidth: 34,
                icon: 'Blender.svg',
                label: 'Blender',
              },
              {
                iconWidth: 40,
                icon: 'SandwichGrill.svg',
                label: 'Sandwich\nGrill',
              },
              {
                iconWidth: 38,
                icon: 'VacuumCleaner.svg',
                label: 'Vacuum\nCleaner',
              },
              {
                iconWidth: 38,
                icon: 'CoffeeMaker.svg',
                label: 'Coffee &nbsp Maker',
              },
              {
                iconWidth: 46,
                icon: 'ElectricKettle.svg',
                label: 'Electric &nbsp Kettle',
              }
            ],
          }
        ],
        buyLink: 'https://www.bluettipower.com/products/eb70s-716wh-800w-portable-power-station-best-solar-generator-for-camping',
      }],
    2: [{
        pic: 'https://cdn.shopify.com/s/files/1/0536/3390/8911/files/choose-AC200P.png?v=1661926545',
        title: 'By your choice, we recommend this product to you', 
        sku: 'AC200P',
        desc: '2000W\n2000Wh\nLFP Battery',
        features: 'No matter where you are, at home during an unexpected outage, in your backyard, on a worksite, in the woods, or on a road trip, you can always count on BLUETTI AC200P as your reliable off-grid power source.',
        videos: ['https://www.youtube.com/embed/Y-xgJNsCnA0'],
        ratedCapacity: 2000,
        choices: [{
            leftLabel: 'MINI',
            powerOfAppliance:40, 
            maxTime:160,
            content: [
              {
                iconWidth: 38,
                icon: 'iphone2.svg',
                label: 'Phone',
              },
              {
                iconWidth: 38,
                icon: 'Macbook.svg',
                label: 'Laptop',
              },
              {
                iconWidth: 38,
                icon: 'Camera.svg',
                label: 'Camera',
              },
              {
                iconWidth: 38,
                icon: 'Drone.svg',
                label: 'Drone',
              },
              {
                iconWidth: 50,
                icon: 'cpap.svg',
                label: 'CPAP',
              },
              {
                iconWidth: 42,
                icon: 'Projector.svg',
                label: 'Projector',
              },{
                iconWidth: 42,
                icon: 'Television.svg',
                label: 'Television',
              }
            ],
          },
          {
            leftLabel: 'NORMAL',
            powerOfAppliance:800, 
            maxTime:9,
            content: [
              {
                iconWidth: 50,
                icon: 'Minifridge.svg',
                label: 'Mini-fridge',
              },
              {
                iconWidth: 38,
                icon: 'VacuumCleaner.svg',
                label: 'Vacuum &nbsp Cleaner',
              },
              {
                iconWidth: 34,
                icon: 'RiceCooker.svg',
                label: 'Rice &nbsp Cooker',
              },
              {
                iconWidth: 38,
                icon: 'CoffeeMaker.svg',
                label: 'Coffee &nbsp Maker',
              },
              {
                iconWidth: 46,
                icon: 'ElectricKettle.svg',
                label: 'Electric Kettle',
              },
              {
                iconWidth: 38,
                icon: 'HairDryer.svg',
                label: 'Hair Dryer',
              },
              {
                iconWidth: 38,
                icon: 'ElectricHammer.svg',
                label: 'Electric Hammer',
              }
            ],
          },{
            leftLabel: 'HEAVY',
            powerOfAppliance:1000, 
            maxTime:8,
            content: [
              {
                iconWidth: 35,
                icon: 'ElectricDrill.svg',
                label: 'Electric Drill',
              },
              {
                iconWidth: 38,
                icon: 'CuttingMachine.svg',
                label: 'Cutting Machine',
              },
              {
                iconWidth: 38,
                icon: 'ElectricGrill.svg',
                label: 'Electric &nbsp Grill',
              },
              {
                iconWidth: 38,
                icon: 'Microwave.svg',
                label: 'Microwave',
              },
              {
                iconWidth: 46,
                icon: 'CircularSaw.svg',
                label: 'Circular Saw',
              },
              {
                iconWidth: 38,
                icon: 'Fridge.svg',
                label: 'Fridge',
              },
              {
                iconWidth: 38,
                icon: 'AirConditioning.svg',
                label: 'Air-Conditioning',
              }
            ],
          }
        ],
        buyLink: 'https://www.bluettipower.com/products/bluetti-ac200p-2000wh-2000w-portable-power-station',
      },{
        pic: 'https://cdn.shopify.com/s/files/1/0536/3390/8911/files/choose-AC200max.png?v=1661926546',
        title: 'By your choice, we recommend this product to you', 
        sku: 'AC200MAX',
        desc: '2200W\n2048Wh\nExpandable',
        features: 'Expandable power station AC200MAX comes with 2,048Wh LiFePO4 cells and 2,200W AC inverter to become your mobile power center at home or on the way.',
        videos: ['https://www.youtube.com/embed/qTUyCIcFC8o', 'https://www.youtube.com/embed/tk1oAASkuSU','https://www.youtube.com/embed/Fl2f6yzv1NY'],
        ratedCapacity: 2048,
        choices: [{
            leftLabel: 'MINI',
            powerOfAppliance:40, 
            maxTime:160,
            content: [
              {
                iconWidth: 38,
                icon: 'iphone2.svg',
                label: 'Phone',
              },
              {
                iconWidth: 38,
                icon: 'Macbook.svg',
                label: 'Laptop',
              },
              {
                iconWidth: 38,
                icon: 'Camera.svg',
                label: 'Camera',
              },
              {
                iconWidth: 38,
                icon: 'Drone.svg',
                label: 'Drone',
              },
              {
                iconWidth: 50,
                icon: 'cpap.svg',
                label: 'CPAP',
              },
              {
                iconWidth: 42,
                icon: 'Projector.svg',
                label: 'Projector',
              },{
                iconWidth: 42,
                icon: 'Television.svg',
                label: 'Television',
              }
            ],
          },
          {
            leftLabel: 'NORMAL',
            powerOfAppliance:800, 
            maxTime:9,
            content: [
              {
                iconWidth: 50,
                icon: 'Minifridge.svg',
                label: 'Mini-fridge',
              },
              {
                iconWidth: 38,
                icon: 'VacuumCleaner.svg',
                label: 'Vacuum &nbsp Cleaner',
              },
              {
                iconWidth: 34,
                icon: 'RiceCooker.svg',
                label: 'Rice &nbsp Cooker',
              },
              {
                iconWidth: 38,
                icon: 'CoffeeMaker.svg',
                label: 'Coffee &nbsp Maker',
              },
              {
                iconWidth: 46,
                icon: 'ElectricKettle.svg',
                label: 'Electric Kettle',
              },
              {
                iconWidth: 38,
                icon: 'HairDryer.svg',
                label: 'Hair Dryer',
              },
              {
                iconWidth: 38,
                icon: 'ElectricHammer.svg',
                label: 'Electric Hammer',
              }
            ],
          },{
            leftLabel: 'HEAVY',
            powerOfAppliance:1000, 
            maxTime:8,
            content: [
              {
                iconWidth: 35,
                icon: 'ElectricDrill.svg',
                label: 'Electric Drill',
              },
              {
                iconWidth: 38,
                icon: 'CuttingMachine.svg',
                label: 'Cutting Machine',
              },
              {
                iconWidth: 38,
                icon: 'ElectricGrill.svg',
                label: 'Electric &nbsp Grill',
              },
              {
                iconWidth: 38,
                icon: 'Microwave.svg',
                label: 'Microwave',
              },
              {
                iconWidth: 46,
                icon: 'CircularSaw.svg',
                label: 'Circular Saw',
              },
              {
                iconWidth: 38,
                icon: 'Fridge.svg',
                label: 'Fridge',
              },
              {
                iconWidth: 38,
                icon: 'AirConditioning.svg',
                label: 'Air-Conditioning',
              }
            ],
          }
        ],
        buyLink: 'https://www.bluettipower.com/products/ac200max-power-station',
      }, {
        pic: 'https://cdn.shopify.com/s/files/1/0536/3390/8911/products/AC200MAX_B230_1000x.png?v=1629796274',
        title: 'By your choice, we recommend this product to you', 
        sku: 'AC200MAX + 1*B230',
        desc: '2200W\n4096Wh\nExpandable',
        features: 'With a built-in 2,200W AC inverter (4,800W surge) and 1*B230 (2,048Wh), this powerful AC200MAX can run almost all of your high-load devices smoothly.',
        videos: ['https://www.youtube.com/embed/qTUyCIcFC8o', 'https://www.youtube.com/embed/tk1oAASkuSU','https://www.youtube.com/embed/Fl2f6yzv1NY'],
        ratedCapacity: 4096,
        choices: [{
            leftLabel: 'MINI',
            powerOfAppliance:40, 
            maxTime:160,
            content: [
              {
                iconWidth: 38,
                icon: 'iphone2.svg',
                label: 'Phone',
              },
              {
                iconWidth: 38,
                icon: 'Macbook.svg',
                label: 'Laptop',
              },
              {
                iconWidth: 38,
                icon: 'Camera.svg',
                label: 'Camera',
              },
              {
                iconWidth: 38,
                icon: 'Drone.svg',
                label: 'Drone',
              },
              {
                iconWidth: 50,
                icon: 'cpap.svg',
                label: 'CPAP',
              },
              {
                iconWidth: 42,
                icon: 'Projector.svg',
                label: 'Projector',
              },{
                iconWidth: 42,
                icon: 'Television.svg',
                label: 'Television',
              }
            ],
          },
          {
            leftLabel: 'NORMAL',
            powerOfAppliance:800, 
            maxTime:9,
            content: [
              {
                iconWidth: 50,
                icon: 'Minifridge.svg',
                label: 'Mini-fridge',
              },
              {
                iconWidth: 38,
                icon: 'VacuumCleaner.svg',
                label: 'Vacuum &nbsp Cleaner',
              },
              {
                iconWidth: 34,
                icon: 'RiceCooker.svg',
                label: 'Rice &nbsp Cooker',
              },
              {
                iconWidth: 38,
                icon: 'CoffeeMaker.svg',
                label: 'Coffee &nbsp Maker',
              },
              {
                iconWidth: 46,
                icon: 'ElectricKettle.svg',
                label: 'Electric Kettle',
              },
              {
                iconWidth: 38,
                icon: 'HairDryer.svg',
                label: 'Hair Dryer',
              },
              {
                iconWidth: 38,
                icon: 'ElectricHammer.svg',
                label: 'Electric Hammer',
              }
            ],
          },{
            leftLabel: 'HEAVY',
            powerOfAppliance:1000, 
            maxTime:8,
            content: [
              {
                iconWidth: 35,
                icon: 'ElectricDrill.svg',
                label: 'Electric Drill',
              },
              {
                iconWidth: 38,
                icon: 'CuttingMachine.svg',
                label: 'Cutting Machine',
              },
              {
                iconWidth: 38,
                icon: 'ElectricGrill.svg',
                label: 'Electric &nbsp Grill',
              },
              {
                iconWidth: 38,
                icon: 'Microwave.svg',
                label: 'Microwave',
              },
              {
                iconWidth: 46,
                icon: 'CircularSaw.svg',
                label: 'Circular Saw',
              },
              {
                iconWidth: 38,
                icon: 'Fridge.svg',
                label: 'Fridge',
              },
              {
                iconWidth: 38,
                icon: 'AirConditioning.svg',
                label: 'Air-Conditioning',
              }
            ],
          }
        ],
        buyLink: 'https://www.bluettipower.com/products/bluetti-ac200max-1-b230-portable-power-station',
      }, {
        pic: 'https://cdn.shopify.com/s/files/1/0536/3390/8911/products/AC200MAX_2xB230_2800x_ebe940a4-6e15-4ca8-9568-aadbe57b1f7e_2000x.webp?v=1657763116',
        title: 'By your choice, we recommend this product to you', 
        sku: 'AC200MAX + 2*B230',
        desc: '2200W\n6144Wh\nExpandable',
        features: 'With a built-in 2200W AC inverter (4,800W surge) and 2*B230 (4,096Wh in total), this powerful AC200MAX can run almost all of your high-load devices smoothly.',
        videos: ['https://www.youtube.com/embed/qTUyCIcFC8o', 'https://www.youtube.com/embed/tk1oAASkuSU', 'https://www.youtube.com/embed/Fl2f6yzv1NY'],
        ratedCapacity: 6144,
        choices: [{
            leftLabel: 'MINI',
            powerOfAppliance:40, 
            maxTime:160,
            content: [
              {
                iconWidth: 38,
                icon: 'iphone2.svg',
                label: 'Phone',
              },
              {
                iconWidth: 38,
                icon: 'Macbook.svg',
                label: 'Laptop',
              },
              {
                iconWidth: 38,
                icon: 'Camera.svg',
                label: 'Camera',
              },
              {
                iconWidth: 38,
                icon: 'Drone.svg',
                label: 'Drone',
              },
              {
                iconWidth: 50,
                icon: 'cpap.svg',
                label: 'CPAP',
              },
              {
                iconWidth: 42,
                icon: 'Projector.svg',
                label: 'Projector',
              },{
                iconWidth: 42,
                icon: 'Television.svg',
                label: 'Television',
              }
            ],
          },
          {
            leftLabel: 'NORMAL',
            powerOfAppliance:800, 
            maxTime:9,
            content: [
              {
                iconWidth: 50,
                icon: 'Minifridge.svg',
                label: 'Mini-fridge',
              },
              {
                iconWidth: 38,
                icon: 'VacuumCleaner.svg',
                label: 'Vacuum &nbsp Cleaner',
              },
              {
                iconWidth: 34,
                icon: 'RiceCooker.svg',
                label: 'Rice &nbsp Cooker',
              },
              {
                iconWidth: 38,
                icon: 'CoffeeMaker.svg',
                label: 'Coffee &nbsp Maker',
              },
              {
                iconWidth: 46,
                icon: 'ElectricKettle.svg',
                label: 'Electric Kettle',
              },
              {
                iconWidth: 38,
                icon: 'HairDryer.svg',
                label: 'Hair Dryer',
              },
              {
                iconWidth: 38,
                icon: 'ElectricHammer.svg',
                label: 'Electric Hammer',
              }
            ],
          },{
            leftLabel: 'HEAVY',
            powerOfAppliance:1000, 
            maxTime:8,
            content: [
              {
                iconWidth: 35,
                icon: 'ElectricDrill.svg',
                label: 'Electric Drill',
              },
              {
                iconWidth: 38,
                icon: 'CuttingMachine.svg',
                label: 'Cutting Machine',
              },
              {
                iconWidth: 38,
                icon: 'ElectricGrill.svg',
                label: 'Electric &nbsp Grill',
              },
              {
                iconWidth: 38,
                icon: 'Microwave.svg',
                label: 'Microwave',
              },
              {
                iconWidth: 46,
                icon: 'CircularSaw.svg',
                label: 'Circular Saw',
              },
              {
                iconWidth: 38,
                icon: 'Fridge.svg',
                label: 'Fridge',
              },
              {
                iconWidth: 38,
                icon: 'AirConditioning.svg',
                label: 'Air-Conditioning',
              }
            ],
          }
        ],
        buyLink: 'https://www.bluettipower.com/products/bluetti-ac200max-2-b230-portable-power-station?_pos=2&_sid=7de3aee55&_ss=r',
      }],
    3: [{
        pic: 'https://cdn.shopify.com/s/files/1/0536/3390/8911/products/1_a93e4b95-841b-4736-8fd2-37ebe78f1db0_2000x.jpg?v=1648724228',
        title: 'By your choice, we recommend this product to you', 
        sku: 'AC300 + 1*B300',
        desc: '3000W\n3072Wh\nExpandable',
        features: 'No matter where you are, at home during an unexpected outage, in your backyard, on a worksite, in the woods, or on a road trip, you can always count on BLUETTI AC200P as your reliable off-grid power source.',
        videos: ['https://www.youtube.com/embed/NCFJrMMiINI','https://www.youtube.com/embed/kGKZG_HOFKQ','https://www.youtube.com/embed/Pag5jJblCUs'],
        ratedCapacity: 3072,
        choices: [
          {
            leftLabel: 'MINI',
            powerOfAppliance:40, 
            maxTime:160,
            content: [
              {
                iconWidth: 38,
                icon: 'iphone2.svg',
                label: 'Phone',
              },
              {
                iconWidth: 38,
                icon: 'Macbook.svg',
                label: 'Laptop',
              },
              {
                iconWidth: 38,
                icon: 'Camera.svg',
                label: 'Camera',
              },
              {
                iconWidth: 38,
                icon: 'Drone.svg',
                label: 'Drone',
              },
              {
                iconWidth: 50,
                icon: 'cpap.svg',
                label: 'CPAP',
              },
              {
                iconWidth: 42,
                icon: 'Projector.svg',
                label: 'Projector',
              },
              {
                iconWidth: 42,
                icon: 'Television.svg',
                label: 'Television',
              },
              {
                iconWidth: 50,
                icon: 'Minifridge.svg',
                label: 'Mini-fridge',
              }
            ],
          },
          {
            leftLabel: 'NORMAL',
            powerOfAppliance:800, 
            maxTime:9,
            content: [
              {
                iconWidth: 38,
                icon: 'Blender.svg',
                label: 'Blender',
              },
              {
                iconWidth: 38,
                icon: 'Microwave.svg',
                label: 'Microwave',
              },
              {
                iconWidth: 38,
                icon: 'VacuumCleaner.svg',
                label: 'Vacuum\nCleaner',
              },
              {
                iconWidth: 34,
                icon: 'RiceCooker.svg',
                label: 'Rice Cooker',
              },
              {
                iconWidth: 38,
                icon: 'CoffeeMaker.svg',
                label: 'Coffee Maker',
              },
              {
                iconWidth: 46,
                icon: 'ElectricKettle.svg',
                label: 'Electric Kettle',
              },
              {
                iconWidth: 38,
                icon: 'HairDryer.svg',
                label: 'Hair &nbsp Dryer',
              },
              {
                iconWidth: 38,
                icon: 'ElectricHammer.svg',
                label: 'Electric Hammer',
              }
            ],
          },{
            leftLabel: 'HEAVY',
            powerOfAppliance:1000, 
            maxTime:8,
            content: [
              {
                iconWidth: 35,
                icon: 'ElectricDrill.svg',
                label: 'Electric Drill',
              },
              {
                iconWidth: 38,
                icon: 'CuttingMachine.svg',
                label: 'Cutting Machine',
              },
              {
                iconWidth: 38,
                icon: 'ElectricGrill.svg',
                label: 'Electric Grill',
              },
              {
                iconWidth: 46,
                icon: 'CircularSaw.svg',
                label: 'Circular Saw',
              },
              {
                iconWidth: 38,
                icon: 'Fridge.svg',
                label: 'Fridge',
              },
              {
                iconWidth: 38,
                icon: 'AirConditioning.svg',
                label: 'Air-Conditioning',
              },
              {
                iconWidth: 38,
                icon: 'HeatPump.svg',
                label: 'Heat Pump',
              },
              {
                iconWidth: 38,
                icon: 'Dryer.svg',
                label: 'Dryer',
              },
            ],
          }
        ],
        buyLink: 'https://www.bluettipower.com/products/ac300-b300',
      },{
        pic: 'https://cdn.shopify.com/s/files/1/0536/3390/8911/products/EP500_8_1000x.jpg?v=1651661702',
        title: 'By your choice, we recommend this product to you', 
        sku: 'EP500',
        desc: '2000W\n5120Wh',
        features: 'Expandable power station-AC200MAX comes with 2,048Wh LiFePO4 cells and 2,200W AC inverter to become your mobile power center at home or on the way.',
        videos: ['https://www.youtube.com/embed/K6Nn_EZvozk'],
        ratedCapacity: 5120,
        choices: [{
            leftLabel: 'MINI',
            powerOfAppliance:40, 
            maxTime:160,
            content: [
              {
                iconWidth: 38,
                icon: 'iphone2.svg',
                label: 'Phone',
              },
              {
                iconWidth: 38,
                icon: 'Macbook.svg',
                label: 'Laptop',
              },
              {
                iconWidth: 38,
                icon: 'Camera.svg',
                label: 'Camera',
              },
              {
                iconWidth: 38,
                icon: 'Drone.svg',
                label: 'Drone',
              },
              {
                iconWidth: 50,
                icon: 'cpap.svg',
                label: 'CPAP',
              },
              {
                iconWidth: 42,
                icon: 'Projector.svg',
                label: 'Projector',
              },
              {
                iconWidth: 42,
                icon: 'Television.svg',
                label: 'Television',
              },
              {
                iconWidth: 50,
                icon: 'Minifridge.svg',
                label: 'Mini-fridge',
              }
            ],
          },
          {
            leftLabel: 'NORMAL',
            powerOfAppliance:800, 
            maxTime:9,
            content: [
              {
                iconWidth: 38,
                icon: 'Blender.svg',
                label: 'Blender',
              },
              {
                iconWidth: 38,
                icon: 'Microwave.svg',
                label: 'Microwave',
              },
              {
                iconWidth: 38,
                icon: 'VacuumCleaner.svg',
                label: 'Vacuum\nCleaner',
              },
              {
                iconWidth: 34,
                icon: 'RiceCooker.svg',
                label: 'Rice Cooker',
              },
              {
                iconWidth: 38,
                icon: 'CoffeeMaker.svg',
                label: 'Coffee Maker',
              },
              {
                iconWidth: 46,
                icon: 'ElectricKettle.svg',
                label: 'Electric Kettle',
              },
              {
                iconWidth: 38,
                icon: 'HairDryer.svg',
                label: 'Hair &nbsp Dryer',
              },
              {
                iconWidth: 38,
                icon: 'ElectricHammer.svg',
                label: 'Electric Hammer',
              }
            ],
          },{
            leftLabel: 'HEAVY',
            powerOfAppliance:1000, 
            maxTime:8,
            content: [
              {
                iconWidth: 35,
                icon: 'ElectricDrill.svg',
                label: 'Electric Drill',
              },
              {
                iconWidth: 38,
                icon: 'CuttingMachine.svg',
                label: 'Cutting Machine',
              },
              {
                iconWidth: 38,
                icon: 'ElectricGrill.svg',
                label: 'Electric Grill',
              },
              {
                iconWidth: 46,
                icon: 'CircularSaw.svg',
                label: 'Circular Saw',
              },
              {
                iconWidth: 38,
                icon: 'Fridge.svg',
                label: 'Fridge',
              },
              {
                iconWidth: 38,
                icon: 'AirConditioning.svg',
                label: 'Air-Conditioning',
              },
              {
                iconWidth: 38,
                icon: 'HeatPump.svg',
                label: 'Heat Pump',
              },
              {
                iconWidth: 38,
                icon: 'Dryer.svg',
                label: 'Dryer',
              },
            ],
          }
        ],
        buyLink: 'https://www.bluettipower.com/products/ep500-2000w-5100wh-solar-generator',
      }, {
        pic: 'https://cdn.shopify.com/s/files/1/0536/3390/8911/products/13_2000x.jpg?v=1648724164',
        title: 'By your choice, we recommend this product to you', 
        sku: 'AC300 + 2*B300',
        desc: '3000W\n6144Wh\nExpandable',
        features: 'With a built-in 2,200W AC inverter (4,800W surge) and 1*B230 (2,048Wh), this powerful AC200MAX can run almost all of your high-load devices smoothly.',
        videos: ['https://www.youtube.com/embed/NCFJrMMiINI', 'https://www.youtube.com/embed/kGKZG_HOFKQ','https://www.youtube.com/embed/Pag5jJblCUs'],
        ratedCapacity: 6144,
        choices: [{
            leftLabel: 'MINI',
            powerOfAppliance:40, 
            maxTime:160,
            content: [
              {
                iconWidth: 38,
                icon: 'iphone2.svg',
                label: 'Phone',
              },
              {
                iconWidth: 38,
                icon: 'Macbook.svg',
                label: 'Laptop',
              },
              {
                iconWidth: 38,
                icon: 'Camera.svg',
                label: 'Camera',
              },
              {
                iconWidth: 38,
                icon: 'Drone.svg',
                label: 'Drone',
              },
              {
                iconWidth: 50,
                icon: 'cpap.svg',
                label: 'CPAP',
              },
              {
                iconWidth: 42,
                icon: 'Projector.svg',
                label: 'Projector',
              },
              {
                iconWidth: 42,
                icon: 'Television.svg',
                label: 'Television',
              },
              {
                iconWidth: 50,
                icon: 'Minifridge.svg',
                label: 'Mini-fridge',
              }
            ],
          },
          {
            leftLabel: 'NORMAL',
            powerOfAppliance:800, 
            maxTime:9,
            content: [
              {
                iconWidth: 38,
                icon: 'Blender.svg',
                label: 'Blender',
              },
              {
                iconWidth: 38,
                icon: 'Microwave.svg',
                label: 'Microwave',
              },
              {
                iconWidth: 38,
                icon: 'VacuumCleaner.svg',
                label: 'Vacuum\nCleaner',
              },
              {
                iconWidth: 34,
                icon: 'RiceCooker.svg',
                label: 'Rice Cooker',
              },
              {
                iconWidth: 38,
                icon: 'CoffeeMaker.svg',
                label: 'Coffee Maker',
              },
              {
                iconWidth: 46,
                icon: 'ElectricKettle.svg',
                label: 'Electric Kettle',
              },
              {
                iconWidth: 38,
                icon: 'HairDryer.svg',
                label: 'Hair &nbsp Dryer',
              },
              {
                iconWidth: 38,
                icon: 'ElectricHammer.svg',
                label: 'Electric Hammer',
              }
            ],
          },{
            leftLabel: 'HEAVY',
            powerOfAppliance:1000, 
            maxTime:8,
            content: [
              {
                iconWidth: 35,
                icon: 'ElectricDrill.svg',
                label: 'Electric Drill',
              },
              {
                iconWidth: 38,
                icon: 'CuttingMachine.svg',
                label: 'Cutting Machine',
              },
              {
                iconWidth: 38,
                icon: 'ElectricGrill.svg',
                label: 'Electric Grill',
              },
              {
                iconWidth: 46,
                icon: 'CircularSaw.svg',
                label: 'Circular Saw',
              },
              {
                iconWidth: 38,
                icon: 'Fridge.svg',
                label: 'Fridge',
              },
              {
                iconWidth: 38,
                icon: 'AirConditioning.svg',
                label: 'Air-Conditioning',
              },
              {
                iconWidth: 38,
                icon: 'HeatPump.svg',
                label: 'Heat Pump',
              },
              {
                iconWidth: 38,
                icon: 'Dryer.svg',
                label: 'Dryer',
              },
            ],
          }
        ],
        buyLink: 'https://www.bluettipower.com/products/ac300-2xb300?_pos=7&_sid=06b3d20bc&_ss=r',
      }, {
        pic: 'https://cdn.shopify.com/s/files/1/0536/3390/8911/products/A_2000x.png?v=1654161187',
        title: 'By your choice, we recommend this product to you', 
        sku: 'EP500Pro',
        desc: '3000W\n5120Wh\nExpandable',
        features: 'With a built-in 2200W AC inverter (4,800W surge) and 2*B230 (4,096Wh in total), this powerful AC200MAX can run almost all of your high-load devices smoothly.',
        videos: ['https://www.youtube.com/embed/hkZsbeREcYk'],
        ratedCapacity: 5120,
        choices: [{
            leftLabel: 'MINI',
            powerOfAppliance:40, 
            maxTime:160,
            content: [
              {
                iconWidth: 38,
                icon: 'iphone2.svg',
                label: 'Phone',
              },
              {
                iconWidth: 38,
                icon: 'Macbook.svg',
                label: 'Laptop',
              },
              {
                iconWidth: 38,
                icon: 'Camera.svg',
                label: 'Camera',
              },
              {
                iconWidth: 38,
                icon: 'Drone.svg',
                label: 'Drone',
              },
              {
                iconWidth: 50,
                icon: 'cpap.svg',
                label: 'CPAP',
              },
              {
                iconWidth: 42,
                icon: 'Projector.svg',
                label: 'Projector',
              },
              {
                iconWidth: 42,
                icon: 'Television.svg',
                label: 'Television',
              },
              {
                iconWidth: 50,
                icon: 'Minifridge.svg',
                label: 'Mini-fridge',
              }
            ],
          },
          {
            leftLabel: 'NORMAL',
            powerOfAppliance:800, 
            maxTime:9,
            content: [
              {
                iconWidth: 38,
                icon: 'Blender.svg',
                label: 'Blender',
              },
              {
                iconWidth: 38,
                icon: 'Microwave.svg',
                label: 'Microwave',
              },
              {
                iconWidth: 38,
                icon: 'VacuumCleaner.svg',
                label: 'Vacuum\nCleaner',
              },
              {
                iconWidth: 34,
                icon: 'RiceCooker.svg',
                label: 'Rice Cooker',
              },
              {
                iconWidth: 38,
                icon: 'CoffeeMaker.svg',
                label: 'Coffee Maker',
              },
              {
                iconWidth: 46,
                icon: 'ElectricKettle.svg',
                label: 'Electric Kettle',
              },
              {
                iconWidth: 38,
                icon: 'HairDryer.svg',
                label: 'Hair &nbsp Dryer',
              },
              {
                iconWidth: 38,
                icon: 'ElectricHammer.svg',
                label: 'Electric Hammer',
              }
            ],
          },{
            leftLabel: 'HEAVY',
            powerOfAppliance:1000, 
            maxTime:8,
            content: [
              {
                iconWidth: 35,
                icon: 'ElectricDrill.svg',
                label: 'Electric Drill',
              },
              {
                iconWidth: 38,
                icon: 'CuttingMachine.svg',
                label: 'Cutting Machine',
              },
              {
                iconWidth: 38,
                icon: 'ElectricGrill.svg',
                label: 'Electric Grill',
              },
              {
                iconWidth: 46,
                icon: 'CircularSaw.svg',
                label: 'Circular Saw',
              },
              {
                iconWidth: 38,
                icon: 'Fridge.svg',
                label: 'Fridge',
              },
              {
                iconWidth: 38,
                icon: 'AirConditioning.svg',
                label: 'Air-Conditioning',
              },
              {
                iconWidth: 38,
                icon: 'HeatPump.svg',
                label: 'Heat Pump',
              },
              {
                iconWidth: 38,
                icon: 'Dryer.svg',
                label: 'Dryer',
              },
            ],
          }
        ],
        buyLink: 'https://www.bluettipower.com/products/bluetti-ep500pro-home-battery-backup',
      },{
        pic: 'https://cdn.shopify.com/s/files/1/0536/3390/8911/products/1_340243d8-168a-4d9c-a9d2-a4320e527dc3_2000x.jpg?v=1649563660',
        title: 'By your choice, we recommend this product to you', 
        sku: 'AC300 + 4*B300',
        desc: '3000W\n12288Wh\nExpandable',
        features: 'No matter where you are, at home during an unexpected outage, in your backyard, on a worksite, in the woods, or on a road trip, you can always count on BLUETTI AC200P as your reliable off-grid power source.',
        videos: ['https://www.youtube.com/embed/NCFJrMMiINI', 'https://www.youtube.com/embed/kGKZG_HOFKQ', 'https://www.youtube.com/embed/Pag5jJblCUs'],
        ratedCapacity: 12288,
        choices: [{
            leftLabel: 'MINI',
            powerOfAppliance:40, 
            maxTime:160,
            content: [
              {
                iconWidth: 38,
                icon: 'iphone2.svg',
                label: 'Phone',
              },
              {
                iconWidth: 38,
                icon: 'Macbook.svg',
                label: 'Laptop',
              },
              {
                iconWidth: 38,
                icon: 'Camera.svg',
                label: 'Camera',
              },
              {
                iconWidth: 38,
                icon: 'Drone.svg',
                label: 'Drone',
              },
              {
                iconWidth: 50,
                icon: 'cpap.svg',
                label: 'CPAP',
              },
              {
                iconWidth: 42,
                icon: 'Projector.svg',
                label: 'Projector',
              },
              {
                iconWidth: 42,
                icon: 'Television.svg',
                label: 'Television',
              },
              {
                iconWidth: 50,
                icon: 'Minifridge.svg',
                label: 'Mini-fridge',
              }
            ],
          },
          {
            leftLabel: 'NORMAL',
            powerOfAppliance:800, 
            maxTime:9,
            content: [
              {
                iconWidth: 38,
                icon: 'Blender.svg',
                label: 'Blender',
              },
              {
                iconWidth: 38,
                icon: 'Microwave.svg',
                label: 'Microwave',
              },
              {
                iconWidth: 38,
                icon: 'VacuumCleaner.svg',
                label: 'Vacuum\nCleaner',
              },
              {
                iconWidth: 34,
                icon: 'RiceCooker.svg',
                label: 'Rice Cooker',
              },
              {
                iconWidth: 38,
                icon: 'CoffeeMaker.svg',
                label: 'Coffee Maker',
              },
              {
                iconWidth: 46,
                icon: 'ElectricKettle.svg',
                label: 'Electric Kettle',
              },
              {
                iconWidth: 38,
                icon: 'HairDryer.svg',
                label: 'Hair &nbsp Dryer',
              },
              {
                iconWidth: 38,
                icon: 'ElectricHammer.svg',
                label: 'Electric Hammer',
              }
            ],
          },{
            leftLabel: 'HEAVY',
            powerOfAppliance:1000, 
            maxTime:8,
            content: [
              {
                iconWidth: 35,
                icon: 'ElectricDrill.svg',
                label: 'Electric Drill',
              },
              {
                iconWidth: 38,
                icon: 'CuttingMachine.svg',
                label: 'Cutting Machine',
              },
              {
                iconWidth: 38,
                icon: 'ElectricGrill.svg',
                label: 'Electric Grill',
              },
              {
                iconWidth: 46,
                icon: 'CircularSaw.svg',
                label: 'Circular Saw',
              },
              {
                iconWidth: 38,
                icon: 'Fridge.svg',
                label: 'Fridge',
              },
              {
                iconWidth: 38,
                icon: 'AirConditioning.svg',
                label: 'Air-Conditioning',
              },
              {
                iconWidth: 38,
                icon: 'HeatPump.svg',
                label: 'Heat Pump',
              },
              {
                iconWidth: 38,
                icon: 'Dryer.svg',
                label: 'Dryer',
              },
            ],
          }
        ],
        buyLink: 'https://www.bluettipower.com/products/ac300-4-b300?_pos=4&_sid=06b3d20bc&_ss=r',
      },{
        pic: 'https://cdn.shopify.com/s/files/1/0536/3390/8911/products/1_43996da2-8299-4eab-9b94-43d1af6bb80e_2000x.jpg?v=1651054125',
        title: 'By your choice, we recommend this product to you', 
        sku: '2*AC300 + 2*B300',
        desc: '6000W\n6144Wh\nHome Energy',
        features: 'Expandable power station-AC200MAX comes with 2,048Wh LiFePO4 cells and 2,200W AC inverter to become your mobile power center at home or on the way.',
        videos: ['https://www.youtube.com/embed/NCFJrMMiINI', 'https://www.youtube.com/embed/kGKZG_HOFKQ','https://www.youtube.com/embed/Pag5jJblCUs'],
        ratedCapacity: 6144,
        choices: [{
            leftLabel: 'MINI',
            powerOfAppliance:40, 
            maxTime:600,
            content: [
              {
                iconWidth: 38,
                icon: 'iphone2.svg',
                label: 'Phone',
              },
              {
                iconWidth: 38,
                icon: 'Macbook.svg',
                label: 'Laptop',
              },
              {
                iconWidth: 38,
                icon: 'Camera.svg',
                label: 'Camera',
              },
              {
                iconWidth: 38,
                icon: 'Drone.svg',
                label: 'Drone',
              },
              {
                iconWidth: 50,
                icon: 'cpap.svg',
                label: 'CPAP',
              },
              {
                iconWidth: 42,
                icon: 'Projector.svg',
                label: 'Projector',
              },
              {
                iconWidth: 42,
                icon: 'Television.svg',
                label: 'Television',
              },
              {
                iconWidth: 50,
                icon: 'Minifridge.svg',
                label: 'Mini-fridge',
              }
            ],
          },
          {
            leftLabel: 'NORMAL',
            powerOfAppliance:800, 
            maxTime:31,
            content: [
              {
                iconWidth: 38,
                icon: 'Blender.svg',
                label: 'Blender',
              },
              {
                iconWidth: 38,
                icon: 'Microwave.svg',
                label: 'Microwave',
              },
              {
                iconWidth: 38,
                icon: 'VacuumCleaner.svg',
                label: 'Vacuum\nCleaner',
              },
              {
                iconWidth: 34,
                icon: 'RiceCooker.svg',
                label: 'Rice Cooker',
              },
              {
                iconWidth: 38,
                icon: 'CoffeeMaker.svg',
                label: 'Coffee Maker',
              },
              {
                iconWidth: 46,
                icon: 'ElectricKettle.svg',
                label: 'Electric Kettle',
              },
              {
                iconWidth: 38,
                icon: 'HairDryer.svg',
                label: 'Hair &nbsp Dryer',
              },
              {
                iconWidth: 38,
                icon: 'ElectricHammer.svg',
                label: 'Electric Hammer',
              }
            ],
          },{
            leftLabel: 'HEAVY',
            powerOfAppliance:1000, 
            maxTime:25,
            content: [
              {
                iconWidth: 35,
                icon: 'ElectricDrill.svg',
                label: 'Electric Drill',
              },
              {
                iconWidth: 38,
                icon: 'CuttingMachine.svg',
                label: 'Cutting Machine',
              },
              {
                iconWidth: 38,
                icon: 'ElectricGrill.svg',
                label: 'Electric Grill',
              },
              {
                iconWidth: 46,
                icon: 'CircularSaw.svg',
                label: 'Circular Saw',
              },
              {
                iconWidth: 38,
                icon: 'Fridge.svg',
                label: 'Fridge',
              },
              {
                iconWidth: 38,
                icon: 'AirConditioning.svg',
                label: 'Air-Conditioning',
              },
              {
                iconWidth: 38,
                icon: 'HeatPump.svg',
                label: 'Heat Pump',
              },
              {
                iconWidth: 38,
                icon: 'Dryer.svg',
                label: 'Dryer',
              },
            ],
          }
        ],
        buyLink: 'https://www.bluettipower.com/products/2xac300-2xb300-p030a?_pos=5&_sid=06b3d20bc&_ss=r',
      }, {
        pic: 'https://cdn.shopify.com/s/files/1/0536/3390/8911/products/2_f8e490a0-fc54-495f-9d4a-829317447c0a_2000x.jpg?v=1651055273',
        title: 'By your choice, we recommend this product to you', 
        sku: '2*AC300 + 4*B300',
        desc: '6000W\n12288Wh\nHome Energy',
        features: 'With a built-in 2,200W AC inverter (4,800W surge) and 1*B230 (2,048Wh), this powerful AC200MAX can run almost all of your high-load devices smoothly.',
        videos: ['https://www.youtube.com/embed/qTUyCIcFC8o', 'https://www.youtube.com/embed/kGKZG_HOFKQ','https://www.youtube.com/embed/Pag5jJblCUs'],
        ratedCapacity: 12288,
        choices: [{
            leftLabel: 'MINI',
            powerOfAppliance:40, 
            maxTime:600,
            content: [
              {
                iconWidth: 38,
                icon: 'iphone2.svg',
                label: 'Phone',
              },
              {
                iconWidth: 38,
                icon: 'Macbook.svg',
                label: 'Laptop',
              },
              {
                iconWidth: 38,
                icon: 'Camera.svg',
                label: 'Camera',
              },
              {
                iconWidth: 38,
                icon: 'Drone.svg',
                label: 'Drone',
              },
              {
                iconWidth: 50,
                icon: 'cpap.svg',
                label: 'CPAP',
              },
              {
                iconWidth: 42,
                icon: 'Projector.svg',
                label: 'Projector',
              },
              {
                iconWidth: 42,
                icon: 'Television.svg',
                label: 'Television',
              },
              {
                iconWidth: 50,
                icon: 'Minifridge.svg',
                label: 'Mini-fridge',
              }
            ],
          },
          {
            leftLabel: 'NORMAL',
            powerOfAppliance:800, 
            maxTime:31,
            content: [
              {
                iconWidth: 38,
                icon: 'Blender.svg',
                label: 'Blender',
              },
              {
                iconWidth: 38,
                icon: 'Microwave.svg',
                label: 'Microwave',
              },
              {
                iconWidth: 38,
                icon: 'VacuumCleaner.svg',
                label: 'Vacuum\nCleaner',
              },
              {
                iconWidth: 34,
                icon: 'RiceCooker.svg',
                label: 'Rice Cooker',
              },
              {
                iconWidth: 38,
                icon: 'CoffeeMaker.svg',
                label: 'Coffee Maker',
              },
              {
                iconWidth: 46,
                icon: 'ElectricKettle.svg',
                label: 'Electric Kettle',
              },
              {
                iconWidth: 38,
                icon: 'HairDryer.svg',
                label: 'Hair &nbsp Dryer',
              },
              {
                iconWidth: 38,
                icon: 'ElectricHammer.svg',
                label: 'Electric Hammer',
              }
            ],
          },{
            leftLabel: 'HEAVY',
            powerOfAppliance:1000, 
            maxTime:25,
            content: [
              {
                iconWidth: 35,
                icon: 'ElectricDrill.svg',
                label: 'Electric Drill',
              },
              {
                iconWidth: 38,
                icon: 'CuttingMachine.svg',
                label: 'Cutting Machine',
              },
              {
                iconWidth: 38,
                icon: 'ElectricGrill.svg',
                label: 'Electric Grill',
              },
              {
                iconWidth: 46,
                icon: 'CircularSaw.svg',
                label: 'Circular Saw',
              },
              {
                iconWidth: 38,
                icon: 'Fridge.svg',
                label: 'Fridge',
              },
              {
                iconWidth: 38,
                icon: 'AirConditioning.svg',
                label: 'Air-Conditioning',
              },
              {
                iconWidth: 38,
                icon: 'HeatPump.svg',
                label: 'Heat Pump',
              },
              {
                iconWidth: 38,
                icon: 'Dryer.svg',
                label: 'Dryer',
              },
            ],
          }
        ],
        buyLink: 'https://www.bluettipower.com/products/2-ac300-4-b300-p030a?_pos=3&_sid=06b3d20bc&_ss=r',
      }, {
        pic: 'https://cdn.shopify.com/s/files/1/0536/3390/8911/products/3_02d9a7f8-2680-4e74-9c08-a5adec8431cb_2000x.jpg?v=1651055859',
        title: 'By your choice, we recommend this product to you', 
        sku: '2*AC300 + 8*B300',
        desc: '6000W\n24576Wh\nHome Energy',
        features: 'With a built-in 2200W AC inverter (4,800W surge) and 2*B230 (4,096Wh in total), this powerful AC200MAX can run almost all of your high-load devices smoothly.',
        videos: ['https://www.youtube.com/embed/qTUyCIcFC8o', 'https://www.youtube.com/embed/kGKZG_HOFKQ', 'https://www.youtube.com/embed/Pag5jJblCUs'],
        ratedCapacity: 24576,
        choices: [{
            leftLabel: 'MINI',
            powerOfAppliance:40, 
            maxTime:600,
            content: [
              {
                iconWidth: 38,
                icon: 'iphone2.svg',
                label: 'Phone',
              },
              {
                iconWidth: 38,
                icon: 'Macbook.svg',
                label: 'Laptop',
              },
              {
                iconWidth: 38,
                icon: 'Camera.svg',
                label: 'Camera',
              },
              {
                iconWidth: 38,
                icon: 'Drone.svg',
                label: 'Drone',
              },
              {
                iconWidth: 50,
                icon: 'cpap.svg',
                label: 'CPAP',
              },
              {
                iconWidth: 42,
                icon: 'Projector.svg',
                label: 'Projector',
              },
              {
                iconWidth: 42,
                icon: 'Television.svg',
                label: 'Television',
              },
              {
                iconWidth: 50,
                icon: 'Minifridge.svg',
                label: 'Mini-fridge',
              }
            ],
          },
          {
            leftLabel: 'NORMAL',
            powerOfAppliance:800, 
            maxTime:31,
            content: [
              {
                iconWidth: 38,
                icon: 'Blender.svg',
                label: 'Blender',
              },
              {
                iconWidth: 38,
                icon: 'Microwave.svg',
                label: 'Microwave',
              },
              {
                iconWidth: 38,
                icon: 'VacuumCleaner.svg',
                label: 'Vacuum\nCleaner',
              },
              {
                iconWidth: 34,
                icon: 'RiceCooker.svg',
                label: 'Rice Cooker',
              },
              {
                iconWidth: 38,
                icon: 'CoffeeMaker.svg',
                label: 'Coffee Maker',
              },
              {
                iconWidth: 46,
                icon: 'ElectricKettle.svg',
                label: 'Electric Kettle',
              },
              {
                iconWidth: 38,
                icon: 'HairDryer.svg',
                label: 'Hair &nbsp Dryer',
              },
              {
                iconWidth: 38,
                icon: 'ElectricHammer.svg',
                label: 'Electric Hammer',
              }
            ],
          },{
            leftLabel: 'HEAVY',
            powerOfAppliance:1000, 
            maxTime:25,
            content: [
              {
                iconWidth: 35,
                icon: 'ElectricDrill.svg',
                label: 'Electric Drill',
              },
              {
                iconWidth: 38,
                icon: 'CuttingMachine.svg',
                label: 'Cutting Machine',
              },
              {
                iconWidth: 38,
                icon: 'ElectricGrill.svg',
                label: 'Electric Grill',
              },
              {
                iconWidth: 46,
                icon: 'CircularSaw.svg',
                label: 'Circular Saw',
              },
              {
                iconWidth: 38,
                icon: 'Fridge.svg',
                label: 'Fridge',
              },
              {
                iconWidth: 38,
                icon: 'AirConditioning.svg',
                label: 'Air-Conditioning',
              },
              {
                iconWidth: 38,
                icon: 'HeatPump.svg',
                label: 'Heat Pump',
              },
              {
                iconWidth: 38,
                icon: 'Dryer.svg',
                label: 'Dryer',
              },
            ],
          }
        ],
        buyLink: 'https://www.bluettipower.com/products/bluetti-2-ac300-8-b300-p030a-8-pv200-combo?_pos=1&_sid=06b3d20bc&_ss=r',
      }],
  },
};
$('.my-ul .my-item').click(function () {
  
  const nextBtnEl = $('#btn-next');
  if (nextBtnEl.attr('disabled')) {
    nextBtnEl.removeAttr('disabled');
  }
  //首页bar
  let checkedItemId = $(this).attr('item-id')
  if (checkedItemId === "1") {
    $('#progress-top').attr('value', 33.3);
  } else if (checkedItemId === "2"){
    $('#progress-top').attr('value', 66.6);
  } else {
    $('#progress-top').attr('value', 100);
  }
});
$('#btn-next').click(function () {
  $('#choose').hide();
  const id = $('.uk-active .my-item').attr('item-id');
  if (id === '1') {
    vars.data = [ ...vars.oldData['1'], ...vars.oldData['2'], ...vars.oldData['3'] ];
  } else if (id === '2') {
    vars.data = [ ...vars.oldData['2'], ...vars.oldData['3'] ];
  } else {
    vars.data = [ ...vars.oldData['3'] ];
  }
  jumpTo('trigger', '1');
  $('#next').show();
})
$('.my-contian-2').on('click', '.btn-box span', function () {
  if (!$(this).hasClass('btn-active')) {
    jumpTo('trigger', $(this).attr('item-id'));
  }
});
$('.my-contian-2').on('click', '#btn-more', function () {
  jumpTo('more');
});
$('.my-contian-2').on('click', '#btn-back', function () {
  jumpTo('back');
});

function jumpTo(action, tab = null) {
  if (action === 'more') {
    // 更多，最大索引加1，因为页面上没有其他操作，最近的两次操作一定存在一个最大索引
    const page = Math.max(...vars.history.slice(-2).map(m => m.index));
    vars.history.push({
      tab: vars.history[vars.history.length - 1].tab,
      index: page + 1,
    });
  } else if (action === 'back') {
    // 返回上一步操作
    vars.history.pop();
  } else {
    // 切换
    const page = [ ...vars.history ].reverse().find(f => f.tab === tab);
    if (page) {
      // 已经打开过
      vars.history.push(page);
    } else {
      // 第一次打开
      vars.history.push({
        tab,
        index: vars.history.length || 0
      });
    }
  }
  const cur = vars.history.length ? vars.history[vars.history.length - 1] : null;
  if (!cur) {
    // 返回上一页
    $('#next').hide();
    $('#choose').show();
    $("html").scrollTop(0);
    return;
  }
  
  const data = vars.data[cur.index];
  $('.my-contian-2').html(`
    <h2 class="my-title-2 uk-text-center" >BLUETTI CHOOSE</h2>
    <div class="my-box uk-child-width-1-1 uk-child-width-1-2@m uk-margin-medium uk-margin-auto" uk-grid>
      <div class="box-l uk-padding-remove" >
        <div class="btn-box">
          <span class="${cur.tab === '1' ? 'btn-active' : ''} btn1" item-id="1">Top Choice</span>
          <span class="${cur.tab === '2' ? 'btn-active' : ''} btn2" item-id="2">2nd Choice</span>
        </div>
        <div class="con-box" uk-grid>
          <div class="uk-width-1-3@m uk-width-1-1 con-box-l uk-margin-auto-vertical">
            <img src="${data.pic}" alt="">
          </div>
          <div class="uk-width-2-3@m uk-width-1-1 con-box-r">
            <p>${data.title}</p>
            <h3>${data.sku}</h3>
            <span style="white-space: pre-line">${data.desc}</span>
            <a class="btn-get" target="_blank" href=${data.buyLink}>Get Powered</a>
          </div>
        </div>
        <div class="line"></div>
        <div class="text-box">
          <h5>Features</h5>
          <span style="white-space: pre-line">${data.features}</span>
        </div>
        <div class="video-box uk-child-width-1-1" uk-grid>
          ${data.videos.map((video, i) => `<div>
            <iframe src="${video}" uk-responsive uk-video="automute: false;autoplay: ${!i}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>`).join('')}
        </div>
      </div>
      <div class="box-r" >
        <h4 class="my-title-3">Your choice</h4>
        <div class="choice-cont">
          ${data.choices.map((choice) => `
            <div>
              <ul class="choice-list uk-margin-auto">
                ${choice.content.map(content => `
                <li>
                  <img class="uk-margin-auto" width="${content.iconWidth}" height="50" class="img-1" src="${imagePath}${content.icon}${imagePathEnd}" uk-svg loading="lazy"/>
                  <span style="white-space: pre-line">${content.label}</span>
                </li>
                  `).join('')}
              </ul>
              <div class="progress-box uk-margin-auto">
                <div class="choice-type"><span>${choice.leftLabel}</span></div>
                <progress class="uk-progress" value="${getProgressValue(getTime(data.ratedCapacity,choice.powerOfAppliance),choice.maxTime)}" max="100"></progress>
                <div class="time"><span>${getTime(data.ratedCapacity,choice.powerOfAppliance)}hour</span></div>
              </div>
            </div>
          `).join('')}
        </div>
        <div class="btn-cont uk-margin-auto">
          <button id="btn-back" class="uk-button uk-button-default uk-text-500 uk-margin-medium-top m-btn-default m-btn-active">BACK</button>
          <button id="btn-more" class="uk-button uk-button-default uk-text-500 uk-margin-medium-top m-btn-default m-btn-active btn-more ${vars.history.find(history => history.index === vars.data.length - 1) || !vars.history.find(f => f.tab === '2') && vars.history.find(history => history.index === vars.data.length - 2) ? '" disabled' : '"'}>MORE</button>
        </div>
      </div>
    </div>
  </div>
  `);
}